import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ModalHeader.css';

interface IModalHeaderProps {
  title?: string | null;
  sortSlot?: React.ReactNode;
}

export const ModalHeader: React.FC<IModalHeaderProps> = ({ title, sortSlot }) => {
  return (
    <div className={styles['header-content']}>
      {title && (
        <div className={styles['header-title']}>
          <UIHeading1 as="h1">{title}</UIHeading1>
        </div>
      )}
      {sortSlot && <div className={styles['header-sort']}>{sortSlot}</div>}
    </div>
  );
};
